import { hapiConfig } from "./config";

export const getDefaultEnvironmentName = () => {
  return hapiConfig[0].accounts[0].name;
};

export const getCurrentEnvironmentName = () => {
  const saved = getSavedEnvironment();
  if (saved) {
    if (checkEnvironmentExists(saved)) return saved;
    else {
      console.error(`The saved environment ${saved} does not exist.`);
    }
  }
  return getDefaultEnvironmentName();
};

export const getCurrentEnvironment = () => {
  const saved = getSavedEnvironment();
  if (saved && checkEnvironmentExists(saved)) {
    return getEnvironment(saved);
  }
  return getEnvironment(getDefaultEnvironmentName());
};

export const getEnvironment = name => {
  for (const config of hapiConfig) {
    for (const account of config.accounts) {
      if (account.name === name) {
        return account;
      }
    }
  }
};

export const checkEnvironmentExists = name => {
  for (const config of hapiConfig) {
    for (const account of config.accounts) {
      if (account.name === name) {
        return true;
      }
    }
  }
  return false;
};

export function getSavedEnvironment() {
  return localStorage.getItem("environmentType");
}

export function setSavedEnvironment(type) {
  console.log(`Setting saved environment to ${type}`);
  localStorage.setItem("environmentType", type);
}
